import { render, staticRenderFns } from "./success-xp.vue?vue&type=template&id=1cc08018&"
import script from "./success-xp.vue?vue&type=script&lang=js&"
export * from "./success-xp.vue?vue&type=script&lang=js&"
import style0 from "./success-xp.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports